import { IUseEventSenderResult } from "@app/interfaces/useSendEvent.interface";
import { PortalType } from "@studyportals/domain-client";

export const useEventSender = (): IUseEventSenderResult => {
	const eligibleTypes = [
		PortalType.MASTER,
		PortalType.BACHELOR,
		PortalType.DISTANCE_LEARNING,
	];

	const sendEvents = (portalType: PortalType): void => {
		sendGlobalAccessInitiativeEvent(portalType);
		sendBestFitEvents(portalType);
		sendWishlistEvents();
	};

	const sendChangeCurrencyEvent = (): void => {
		const event = new CustomEvent("open_localization_settings");
		document.dispatchEvent(event);
	};

	const sendGlobalAccessInitiativeEvent = (portalType: PortalType): void => {
		if (!eligibleTypes.includes(portalType)) return;

		sendCustomEvent("profile_questionnaires_initialize", {
			identifier: "search_global_access_initiative_label",
		});

		sendCustomEvent("profile_questionnaires_initialize", {
			identifier: "search_scholarship_incentive_label",
		});
	};

	const sendBestFitEvents = (portalType: PortalType): void => {
		if(portalType !== PortalType.MASTER) return;

		sendCustomEvent("profile_questionnaires_initialize", {
			identifier: "bestfit_search",
		});

		sendCustomEvent("render_best_fit_templates");
	};
	const sendRecommendationsInitializationEvent = (identifier: string): void => {
		sendCustomEvent("recommendations_initialize", {
			identifier,
		});
	};

	const updateRecommendations = (dataIdentifier: string, countries?:string, disciplines?:string): void => {
		document.dispatchEvent(new CustomEvent('recommendations_update_filters', {
			detail: {
				identifier: dataIdentifier,
				countries,
				disciplines,
			}
		}))
	};

	const subscribeToRecommendationsEvents = (identifier: string): void => {
		document.addEventListener('recommendations_ready', () => {
			sendRecommendationsInitializationEvent(identifier);
		});

		document.addEventListener('contentChanged', () => {
			sendRecommendationsInitializationEvent(identifier);
		});
	};

	const sendWishlistEvents = (): void => {
		sendCustomEvent("wishlist_button_initialize");
	};

	const sendCustomEvent = (
		eventName: string,
		detail: Record<string, unknown> = {},
	): void => {
		document.dispatchEvent(new CustomEvent(eventName, { detail }));
	};

	return {
		sendChangeCurrencyEvent,
		sendEvents,
		subscribeToRecommendationsEvents,
		sendRecommendationsInitializationEvent,
		updateRecommendations,
	};
};
